export const environment = {
    production: false,
    apiUrl: 'demo.wingsfarm.eu',
    apiType: "https",
    apiPort: "",
    keycloakRealm: "agnes-dev",
    keycloakClientId: "agnes-client",
    enableDebug: false,
    keycloakUrl: "https://sso.wings-ict-solutions.dev/auth",
    uruguayFeatures: false,
    greekFeatures: true
  };


